import { render } from "./ModalCard.vue?vue&type=template&id=4fa1fdd4&scoped=true&ts=true&lang=pug"
import script from "./ModalCard.vue?vue&type=script&lang=ts"
export * from "./ModalCard.vue?vue&type=script&lang=ts"

import "./ModalCard.vue?vue&type=style&index=0&id=4fa1fdd4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa1fdd4"]])

export default __exports__